import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 188.62,
			cy: 111.49,
			r: 103.81,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M31.07 250.43h162.58l33.26-153.3a7.72 7.72 0 0 0-7.55-9.36H61.95c-4.89 0-9.12 3.4-10.15 8.19L21 237.94a10.3 10.3 0 0 0 10.07 12.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M193.65 252H31.07c-3.6 0-6.98-1.62-9.24-4.42a11.8 11.8 0 0 1-2.36-9.97l30.8-141.99a12 12 0 0 1 11.68-9.41h157.4a9.2 9.2 0 0 1 7.24 3.46 9.3 9.3 0 0 1 1.84 7.8l-33.25 153.3c-.15.71-.8 1.22-1.53 1.22M61.95 89.33a8.9 8.9 0 0 0-8.63 6.96l-30.8 141.98a8.7 8.7 0 0 0 1.74 7.34 8.7 8.7 0 0 0 6.81 3.26h161.32L225.38 96.8a6.13 6.13 0 0 0-6.02-7.47z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M248.86 250.43H98.85a12.4 12.4 0 0 1-12.11-9.76L59.32 114.25l-4.08-18.8a6.33 6.33 0 0 1 6.18-7.68h162.42a6.3 6.3 0 0 1 6.18 4.99l4.66 21.5 26.29 121.16a12.4 12.4 0 0 1-12.11 15.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M248.86 252H98.85a14 14 0 0 1-13.64-11L53.71 95.77a7.9 7.9 0 0 1 1.57-6.62 7.9 7.9 0 0 1 6.14-2.94h162.42a7.94 7.94 0 0 1 7.7 6.22l30.95 142.65c.9 4.15-.11 8.42-2.77 11.72s-6.62 5.2-10.86 5.2M61.41 89.33a4.74 4.74 0 0 0-4.65 5.78l31.5 145.23a10.9 10.9 0 0 0 10.58 8.53h150c3.3 0 6.37-1.47 8.43-4.03a10.8 10.8 0 0 0 2.16-9.1L228.49 93.1a4.8 4.8 0 0 0-4.65-3.76z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M105.3 150.95H82.28a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.38-.63-2.89a.97.97 0 0 1 .95-1.17h24.9c.46 0 .86.31.96.76l.71 3.3 4.03 18.58a1.9 1.9 0 0 1-1.86 2.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M105.3 152.52H82.28a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.28a2.52 2.52 0 0 1 2.48-3.07h24.9c1.19 0 2.23.84 2.48 2l4.75 21.88a3.45 3.45 0 0 1-3.39 4.2Zm-28.02-24.95 4.68 21.56c.03.15.17.26.33.26h23c.14 0 .22-.07.27-.12.04-.06.1-.16.06-.29l-4.64-21.41zm69.28 23.38h-23a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.38-.63-2.89a.97.97 0 0 1 .94-1.17h24.92c.45 0 .85.31.94.76l.72 3.3 4.03 18.58a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M146.56 152.52h-23a3.5 3.5 0 0 1-3.4-2.73l-4.82-22.28a2.53 2.53 0 0 1 2.47-3.07h24.91c1.19 0 2.23.84 2.48 2l4.75 21.88a3.45 3.45 0 0 1-3.39 4.2m-28.01-24.95 4.67 21.56c.04.15.18.26.33.26h23.01c.14 0 .22-.07.27-.12.04-.06.1-.16.06-.29l-4.64-21.41zm69.28 23.38h-23a1.9 1.9 0 0 1-1.87-1.5l-4.2-19.38-.63-2.89a.97.97 0 0 1 .95-1.17H184c.46 0 .85.31.95.76l.72 3.3 4.03 18.58a1.9 1.9 0 0 1-1.86 2.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M187.83 152.52h-23a3.5 3.5 0 0 1-3.4-2.73l-4.83-22.28a2.52 2.52 0 0 1 2.48-3.07H184c1.19 0 2.23.84 2.48 2l4.74 21.88a3.44 3.44 0 0 1-3.38 4.2Zm-28.02-24.95 4.68 21.56c.03.15.17.26.33.26h23c.14 0 .23-.07.27-.12q.1-.1.07-.29l-4.65-21.41zm69.29 23.38h-23.01a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.38-.63-2.89a.97.97 0 0 1 .95-1.17h24.91c.46 0 .85.31.95.76l.71 3.3 4.04 18.58a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M229.1 152.52h-23.01a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.28a2.52 2.52 0 0 1 2.48-3.07h24.91c1.18 0 2.23.84 2.48 2l4.74 21.88a3.44 3.44 0 0 1-3.38 4.2m-28.02-24.95 4.68 21.56c.03.15.17.26.33.26h23c.14 0 .23-.07.27-.12q.1-.1.07-.29l-4.65-21.41zm-86.55 66.48h-23a1.9 1.9 0 0 1-1.87-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.91c.46 0 .85.32.95.77l.72 3.3 4.03 18.58a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M114.53 195.61h-23a3.5 3.5 0 0 1-3.4-2.73l-4.83-22.27a2.53 2.53 0 0 1 2.48-3.07h24.91c1.19 0 2.23.84 2.48 2l4.74 21.88a3.45 3.45 0 0 1-3.38 4.2ZM86.5 170.66l4.68 21.56q.08.26.33.27h23c.14 0 .23-.07.27-.13q.1-.09.07-.28l-4.65-21.41zm69.29 23.39h-23.01a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.91c.46 0 .85.32.95.77l.71 3.3 4.03 18.58a1.9 1.9 0 0 1-1.85 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M155.8 195.61h-23.01a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.27a2.52 2.52 0 0 1 2.48-3.07h24.9c1.2 0 2.24.84 2.49 2l4.74 21.88a3.44 3.44 0 0 1-3.38 4.2Zm-28.02-24.95 4.68 21.56c.03.15.17.27.33.27h23c.14 0 .22-.07.27-.13q.1-.09.07-.28l-4.65-21.41zm69.28 23.39h-23a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.9c.46 0 .86.32.96.77l.71 3.3 4.03 18.58a1.9 1.9 0 0 1-1.85 2.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M197.06 195.61h-23a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.27a2.52 2.52 0 0 1 2.48-3.07h24.9c1.19 0 2.23.84 2.48 2l4.75 21.88a3.44 3.44 0 0 1-3.38 4.2Zm-28.01-24.95 4.68 21.56c.03.16.17.27.33.27h23c.14 0 .22-.07.27-.13.04-.06.1-.15.06-.28l-4.64-21.41zm69.28 23.39h-23a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.64-2.88a.97.97 0 0 1 .95-1.18h24.91c.46 0 .86.32.95.77l.72 3.3 4.03 18.58a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M238.33 195.61h-23a3.5 3.5 0 0 1-3.4-2.73l-4.82-22.27a2.52 2.52 0 0 1 2.47-3.07h24.91c1.19 0 2.23.84 2.48 2l4.75 21.88a3.44 3.44 0 0 1-3.39 4.2Zm-28.01-24.95 4.67 21.56c.04.16.18.27.33.27h23.01c.14 0 .22-.07.26-.13s.1-.15.07-.28l-4.64-21.41zm-86.56 66.49h-23a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.9c.46 0 .86.32.96.76l.71 3.3 4.03 18.59a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M123.76 238.71h-23a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.27a2.53 2.53 0 0 1 2.47-3.08h24.92c1.18 0 2.22.84 2.47 2l4.75 21.88a3.45 3.45 0 0 1-3.39 4.2m-28.01-24.95 4.68 21.56c.03.15.17.26.33.26h23q.2-.01.27-.12c.04-.06.1-.15.06-.28l-4.64-21.42zm69.28 23.39h-23a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .94-1.18h24.92c.45 0 .85.32.94.76l.72 3.3 4.03 18.59a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M165.03 238.71h-23a3.5 3.5 0 0 1-3.4-2.73l-4.82-22.27a2.52 2.52 0 0 1 2.47-3.07h24.91c1.19 0 2.23.84 2.48 2l4.75 21.87a3.44 3.44 0 0 1-3.39 4.2m-28.01-24.95 4.67 21.56c.04.15.18.26.33.26h23.01q.2-.01.26-.12.1-.09.07-.28l-4.64-21.42zm69.28 23.39h-23a1.9 1.9 0 0 1-1.87-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.91c.46 0 .85.32.95.76l.72 3.3 4.03 18.59a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M206.3 238.71h-23a3.5 3.5 0 0 1-3.4-2.73l-4.82-22.27a2.52 2.52 0 0 1 2.47-3.07h24.91c1.19 0 2.23.84 2.48 2l4.75 21.87a3.44 3.44 0 0 1-3.39 4.2m-28.01-24.95 4.67 21.56c.03.15.17.26.33.26h23.01q.2-.01.26-.12.1-.09.07-.28l-4.65-21.42zm69.28 23.39h-23.01a1.9 1.9 0 0 1-1.86-1.5l-4.2-19.39-.63-2.88a.97.97 0 0 1 .95-1.18h24.91c.46 0 .85.32.95.76l.71 3.3 4.04 18.59a1.9 1.9 0 0 1-1.86 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M247.57 238.71h-23.01a3.5 3.5 0 0 1-3.39-2.73l-4.83-22.27a2.52 2.52 0 0 1 2.48-3.07h24.9c1.2 0 2.23.83 2.49 1.99l4.74 21.88a3.44 3.44 0 0 1-3.38 4.2m-28.02-24.95 4.68 21.56c.03.15.17.26.33.26h23q.2-.01.27-.12.1-.09.07-.28l-4.65-21.42z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M234.68 114.25H59.32l-4.08-18.8a6.33 6.33 0 0 1 6.18-7.68h162.42a6.3 6.3 0 0 1 6.18 4.99z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M234.68 115.82H59.32c-.74 0-1.37-.52-1.53-1.24l-4.08-18.8a7.9 7.9 0 0 1 1.57-6.63 7.9 7.9 0 0 1 6.14-2.94h162.42a7.94 7.94 0 0 1 7.7 6.22l4.67 21.5a1.56 1.56 0 0 1-1.53 1.89m-174.1-3.13h172.16l-4.25-19.6a4.8 4.8 0 0 0-4.66-3.76H61.43a4.74 4.74 0 0 0-4.66 5.78z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M81.54 103.57a1.71 1.71 0 0 1 0-3.42c3.4 0 6.62-1.33 9.03-3.74s3.74-5.62 3.74-9.03A12.73 12.73 0 0 0 81.54 74.6a12.7 12.7 0 0 0-9.03 3.74 12.7 12.7 0 0 0-3.75 9.04 1.71 1.71 0 1 1-3.42 0c0-4.33 1.69-8.4 4.75-11.46s7.12-4.74 11.45-4.74 8.4 1.68 11.45 4.74c3.06 3.06 4.74 7.13 4.74 11.46S96.05 95.77 93 98.83a16 16 0 0 1-11.45 4.74Zm42.38 0a1.71 1.71 0 0 1 0-3.42 12.7 12.7 0 0 0 9.04-3.74 12.7 12.7 0 0 0 3.74-9.03 12.73 12.73 0 0 0-12.78-12.78c-3.42 0-6.62 1.33-9.03 3.74a12.7 12.7 0 0 0-3.74 9.04 1.71 1.71 0 1 1-3.42 0c0-4.33 1.68-8.4 4.74-11.46s7.13-4.74 11.45-4.74 8.4 1.68 11.46 4.74 4.74 7.13 4.74 11.46-1.68 8.39-4.74 11.45a16 16 0 0 1-11.46 4.74m42.39 0a1.71 1.71 0 0 1 0-3.42c3.41 0 6.62-1.33 9.03-3.74s3.74-5.62 3.74-9.03a12.73 12.73 0 0 0-12.77-12.78 12.7 12.7 0 0 0-9.03 3.74 12.7 12.7 0 0 0-3.74 9.04 1.71 1.71 0 0 1-3.43 0c0-4.33 1.69-8.4 4.75-11.46s7.12-4.74 11.45-4.74 8.4 1.68 11.45 4.74c3.06 3.06 4.75 7.13 4.75 11.46s-1.69 8.39-4.75 11.45a16 16 0 0 1-11.45 4.74m42.39 0a1.71 1.71 0 0 1 0-3.42c3.4 0 6.62-1.33 9.03-3.74s3.74-5.62 3.74-9.03A12.73 12.73 0 0 0 208.7 74.6c-3.41 0-6.62 1.33-9.04 3.74a12.7 12.7 0 0 0-3.74 9.04 1.71 1.71 0 0 1-3.42 0c0-4.33 1.69-8.4 4.74-11.46s7.13-4.74 11.46-4.74 8.39 1.68 11.45 4.74 4.74 7.13 4.74 11.46-1.68 8.39-4.74 11.45a16 16 0 0 1-11.45 4.74"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 217.92,
			cy: 183.18,
			r: 44.46,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M218.02 230.32q-4.36 0-8.74-.82a46.8 46.8 0 0 1-30.23-19.68 46.8 46.8 0 0 1-7.45-35.29 47.2 47.2 0 0 1 54.97-37.67 47.2 47.2 0 0 1 37.68 54.96 46.8 46.8 0 0 1-19.69 30.23 47 47 0 0 1-26.54 8.27m-.12-88.94a41.86 41.86 0 0 0-41.06 34.13 41.5 41.5 0 0 0 6.6 31.3 41.5 41.5 0 0 0 26.81 17.45 41.85 41.85 0 0 0 48.76-33.41 41.84 41.84 0 0 0-41.1-49.47m43.73 49.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m255.76 242.1-9.6 5.4-12.1-21.42a3.15 3.15 0 0 1 .37-3.62 10.3 10.3 0 0 1 5.92-3.35 3.2 3.2 0 0 1 3.3 1.55z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M246.16 249.03a1.5 1.5 0 0 1-1.32-.77l-12.1-21.43a4.7 4.7 0 0 1 .54-5.38 12 12 0 0 1 6.8-3.84 4.7 4.7 0 0 1 4.9 2.3l12.1 21.43c.42.73.16 1.66-.57 2.08l-9.6 5.41q-.35.2-.75.2m-5.25-28.45-.3.02a8.8 8.8 0 0 0-5.04 2.86 1.6 1.6 0 0 0-.18 1.87l11.35 20.1 6.95-3.92-11.36-20.1a1.6 1.6 0 0 0-1.42-.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m254.23 236.45-12.13 6.84-.78-1.38c-.55-.97-.29-2.2.61-2.87a41 41 0 0 1 8.74-4.93 2.2 2.2 0 0 1 2.78.95z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M242.1 244.81a1.5 1.5 0 0 1-1.32-.77l-.78-1.38a3.74 3.74 0 0 1 1.03-4.84 43 43 0 0 1 9.06-5.12 3.75 3.75 0 0 1 4.68 1.61l.78 1.39c.42.73.16 1.66-.57 2.07l-12.13 6.85q-.36.2-.74.2m9.42-9.35-.27.05a40 40 0 0 0-8.41 4.75.7.7 0 0 0-.2.9l.04.06 9.47-5.35-.03-.06a.7.7 0 0 0-.6-.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M278.18 275.17c1 1.78 1.03 3.96.04 5.76a11 11 0 0 1-3.57 3.95 11.3 11.3 0 0 1-6.87 1.89 5.9 5.9 0 0 1-4.93-3.01l-21.06-37.32a3.2 3.2 0 0 1 .74-4.02 34 34 0 0 1 10.73-6.06 3.2 3.2 0 0 1 3.83 1.45z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m268.28 288.3-.56-.01a7.4 7.4 0 0 1-6.2-3.79l-21.06-37.31a4.7 4.7 0 0 1 1.09-5.94 36 36 0 0 1 11.22-6.33 4.7 4.7 0 0 1 5.64 2.14l21.1 37.36a7.4 7.4 0 0 1 .05 7.24 13 13 0 0 1-4.06 4.48 13 13 0 0 1-7.22 2.16m-13.97-50.6q-.28 0-.55.1a33 33 0 0 0-10.26 5.78 1.7 1.7 0 0 0-.39 2.11l21.07 37.32a4.4 4.4 0 0 0 3.66 2.24 9.7 9.7 0 0 0 9.05-5.06 4.4 4.4 0 0 0-.03-4.28l-21.1-37.36c-.3-.53-.86-.85-1.45-.85"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 216.21,
			cy: 180.09,
			r: 44.46,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M216.23 226.08q-4.19 0-8.45-.78a45.7 45.7 0 0 1-29.5-19.2 45.7 45.7 0 0 1-7.27-34.44 46.03 46.03 0 0 1 53.64-36.77 46.03 46.03 0 0 1 36.76 53.64 46.06 46.06 0 0 1-45.18 37.55m-.03-88.93a43 43 0 0 0-42.2 35.07 42.7 42.7 0 0 0 6.8 32.15 42.7 42.7 0 0 0 27.54 17.93 43 43 0 0 0 50.08-34.33 43 43 0 0 0-42.22-50.82"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 216.21,
			cy: 180.09,
			r: 36.67,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M216.23 218.29q-3.48 0-7.02-.65a38.23 38.23 0 0 1-30.54-44.55 38.23 38.23 0 0 1 44.55-30.53 38 38 0 0 1 24.5 15.95 38 38 0 0 1 6.03 28.6 38.25 38.25 0 0 1-37.52 31.18m-.03-73.34a35.2 35.2 0 0 0-34.53 28.7 35.2 35.2 0 0 0 28.1 41 35 35 0 0 0 26.31-5.57 35 35 0 0 0 14.68-22.54 35 35 0 0 0-5.56-26.31 35 35 0 0 0-29-15.28"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "M221.37 152.47a28.1 28.1 0 0 1 22.47 32.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M243.84 186.77q-.15 0-.28-.02a1.5 1.5 0 0 1-1.22-1.78 26.4 26.4 0 0 0-4.2-19.9 26.4 26.4 0 0 0-17.05-11.1 1.52 1.52 0 0 1 .56-3 29.66 29.66 0 0 1 23.68 34.56 1.5 1.5 0 0 1-1.49 1.24m-169.75-50.8a44.44 44.44 0 1 0 0-88.86h-7.32v88.87z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M74.09 137.34h-7.32c-.75 0-1.35-.61-1.35-1.36V47.1c0-.75.6-1.35 1.35-1.35h7.32c25.25 0 45.8 20.54 45.8 45.8s-20.55 45.79-45.8 45.79m-5.96-2.72h5.96c23.75 0 43.08-19.32 43.08-43.08S97.84 48.46 74.09 48.46h-5.96z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66.77,
			cy: 91.54,
			r: 44.44,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M66.77 137.34c-25.25 0-45.8-20.55-45.8-45.8s20.55-45.8 45.8-45.8 45.8 20.55 45.8 45.8-20.55 45.8-45.8 45.8m0-88.88c-23.75 0-43.08 19.33-43.08 43.08s19.33 43.08 43.08 43.08 43.08-19.32 43.08-43.08-19.32-43.08-43.08-43.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m39.95 104.9 40.69-39.92 12.95 13.2-40.68 39.92z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m40.21 77.68 13.21-12.95 39.91 40.68-13.2 12.95z"
		})
	]
});
export default SvgEmptyCalendar;
